export const FETCH_REPORTS = 'Reports/FETCH_REPORTS';
export const FETCH_REPORTS_SUCCESS = 'Reports/FETCH_REPORTS_SUCCESS';
export const FETCH_REPORTS_FAILURE = 'Reports/FETCH_REPORTS_FAILURE';

export const EMPTY_REPORTS = 'Reports/EMPTY_REPORTS';
export const UPDATE_REPORTS = 'Reports/UPDATE_REPORTS';



// WEBPACK FOOTER //
// ./src/containers/ReportsPage/store/constants.js